var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-cross-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 5.99998C17.8125 5.81251 17.5581 5.70719 17.293 5.70719C17.0278 5.70719 16.7735 5.81251 16.586 5.99998L12 10.586L7.41398 5.99998C7.22645 5.81251 6.97214 5.70719 6.70698 5.70719C6.44181 5.70719 6.18751 5.81251 5.99998 5.99998C5.81251 6.18751 5.70719 6.44181 5.70719 6.70698C5.70719 6.97214 5.81251 7.22645 5.99998 7.41398L10.586 12L5.99998 16.586C5.81251 16.7735 5.70719 17.0278 5.70719 17.293C5.70719 17.5581 5.81251 17.8125 5.99998 18C6.18751 18.1875 6.44181 18.2928 6.70698 18.2928C6.97214 18.2928 7.22645 18.1875 7.41398 18L12 13.414L16.586 18C16.7735 18.1875 17.0278 18.2928 17.293 18.2928C17.5581 18.2928 17.8125 18.1875 18 18C18.1875 17.8125 18.2928 17.5581 18.2928 17.293C18.2928 17.0278 18.1875 16.7735 18 16.586L13.414 12L18 7.41398C18.1875 7.22645 18.2928 6.97214 18.2928 6.70698C18.2928 6.44181 18.1875 6.18751 18 5.99998V5.99998Z",
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.efcc07ecad9141df3ad62fbcd478280d.svg";
export { ForwardRef as ReactComponent };